var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMaintenance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9C21.9853 9 24 6.98528 24 4.5C24 3.83969 23.8578 3.2126 23.6023 2.64769L21 5.25H18.75V3L21.3523 0.397693C20.7874 0.142218 20.1603 0 19.5 0C17.0147 0 15 2.01472 15 4.5C15 4.95463 15.0674 5.39351 15.1928 5.8072L5.8072 15.1928C5.39351 15.0674 4.95463 15 4.5 15C2.01472 15 0 17.0147 0 19.5C0 20.1603 0.142218 20.7874 0.397693 21.3523L3 18.75H5.25V21L2.64769 23.6023C3.2126 23.8578 3.83969 24 4.5 24C6.98528 24 9 21.9853 9 19.5C9 19.0454 8.93258 18.6065 8.8072 18.1928L18.1928 8.8072C18.6065 8.93258 19.0454 9 19.5 9Z",
    fill: "#FF552E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 3.75V2.25L2.25 0L0 2.25L2.25 5.25H3.75L6.75 8.25L6 9C5.58579 9.41421 5.58579 10.0858 6 10.5C6.41421 10.9142 7.08579 10.9142 7.5 10.5L10.5 7.5C10.9142 7.08579 10.9142 6.41421 10.5 6C10.0858 5.58579 9.41421 5.58579 9 6L8.25 6.75L5.25 3.75Z",
    fill: "#FF552E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 23.25L13.5 16.5L16.5 13.5L23.25 20.25C23.6642 20.6642 24 21.2071 24 21.75C24 22.2929 23.6642 22.8358 23.25 23.25C22.8358 23.6642 22.2929 24 21.75 24C21.2071 24 20.6642 23.6642 20.25 23.25Z",
    fill: "#FF552E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaintenance);
export default __webpack_public_path__ + "static/media/icon-maintenance.bf4829ae81bed629ff69c42bb10aa2b8.svg";
export { ForwardRef as ReactComponent };